const translations = {
  en: {
    // Header
    nav: {
      highlights: "Highlights",
      location: "Location",
      amenities: "Amenities",
      reviews: "Reviews",
      availability: "Availability",
      contactUs: "Contact Us",
      whatsappContact: "WhatsApp Contact",
    },
    // Hero
    hero: {
      subtitle: "Roman-Inspired Luxury Villa in the Heart of Istria",
      perfectRating: "5.0 Perfect Rating",
      upToGuests: "Up to {n} Guests",
      bedrooms: "{n} Bedrooms",
      bathrooms: "{n} Bathrooms",
      cta: "Check Dates & WhatsApp Offer",
      whatsapp: "Hello! I'm interested in Villa in Pietra. Could you please send me availability and pricing information?",
    },
    // Video Tour
    videoTour: {
      badge: "Video Tour",
      title: "Experience Villa in Pietra",
      description: "Take a cinematic journey through our luxury villa and discover what makes it special",
      pool: "50m² Private Pool",
      antiques: "Roman Antiques",
      estate: "2,500m² Estate",
      bedrooms: "4 En-Suite Bedrooms",
    },
    // Villa Story
    villaStory: {
      badge: "The Villa",
      title: "Where Roman Elegance Meets Istrian Authenticity",
      p1: 'Welcome to <strong>Villa in Pietra</strong>, an exclusive luxury retreat nestled in the picturesque village of Bajkini, Istria. This charming L-shaped villa is a perfect blend of Istrian character, elegant design, and total privacy.',
      p2: 'Upon entering, you are greeted by a beautiful <strong>open-air lounge with a fireplace</strong> – the central heart of the house, designed for relaxation and socializing. The spacious terrace features a <strong>50m² swimming pool, jacuzzi, and sun loungers</strong> – perfect for soaking up the Istrian sun.',
      p3: 'Villa in Pietra is filled with soul and character, thanks to <strong>carefully selected antiques dating back several centuries</strong>, originating from Istria, Tuscany, and Sicily. Every detail tells a story and creates a uniquely refined and authentic atmosphere.',
      p4: 'The villa sits on a <strong>2,500m² private estate</strong>, offering full peace and exclusivity – ideal for families, groups of friends, or couples seeking a luxurious holiday in the heart of Istria.',
      heritageBadge: "Heritage & Antiques",
      heritageTitle: "A Living Museum of Centuries Past",
      heritageDesc: "Each piece tells a story, sourced from historic estates across Istria, Tuscany, and Sicily",
      features: [
        { title: "Medieval Tapestries", description: "Rare hunting scenes and maritime tapestries from the 16th-17th centuries" },
        { title: "Roman Artifacts", description: "Ancient columns, capitals, and architectural elements repurposed as furniture" },
        { title: "Istrian Antiques", description: "Handpicked pieces from local estates, each with centuries of history" },
        { title: "Tuscan & Sicilian Treasures", description: "Carefully curated furniture and decorative arts from Italian nobility" },
      ],
    },
    // Highlights
    highlights: {
      badge: "Villa Highlights",
      title: "Unparalleled Luxury & Privacy",
      description: "Experience the perfect blend of ancient elegance and modern comfort",
      items: [
        { title: "Private 50m² Pool & Jacuzzi", description: "Exclusive swimming pool and heated jacuzzi surrounded by Mediterranean garden" },
        { title: "4 En-Suite Bedrooms", description: "Each bedroom with private bathroom, antique furnishings, and modern comfort" },
        { title: "2,500m² Private Estate", description: "Complete privacy in peaceful hillside village, surrounded by vineyards" },
        { title: "Roman Villa Atmosphere", description: "Centuries-old antiques from Istria, Tuscany & Sicily - authentic luxury" },
      ],
    },
    // Gallery
    gallery: {
      badge: "Photo Gallery",
      title: "Explore Villa in Pietra",
      description: "Discover every corner of our Roman-inspired luxury villa",
      allPhotos: "All Photos",
      exterior: "Exterior & Pool",
      living: "Living Rooms",
      kitchen: "Kitchen",
      dining: "Dining",
      outdoor: "Outdoor Lounge",
      bedroom: "Bedrooms",
      bathroom: "Bathrooms",
      antiques: "Antiques",
      entertainment: "Entertainment & Family",
      footer: "{n} photos • Want to see more? Contact us for a complete photo tour and virtual experience",
    },
    // Availability
    availability: {
      badge: "Live Availability",
      title: "Check Real-Time Availability",
      description: "See available dates, pricing, and special offers at a glance",
      previous: "← Previous",
      next: "Next →",
      available: "Available",
      lastMinute: "Last Minute (-10%)",
      booked: "Booked",
      past: "Past",
      weekdays: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      perNight: "per night",
      off: "OFF!",
      seasonalPricing: "Seasonal Pricing",
      peakSummer: "Peak Summer",
      summerHigh: "Summer High",
      lowSeason: "Low Season",
      minimumStay: "Minimum stay:",
      nights: "nights",
      deposit: "Deposit:",
      atCheckin: "at check-in",
      cleaningFee: "Cleaning fee:",
      lastMinuteLabel: "Last minute:",
      offBookings: "off bookings within 14 days",
      requestQuote: "Request Custom Quote",
      disclaimer: "Calendar synced with Airbnb. For real-time confirmation and special requests, please contact us directly via WhatsApp.",
      syncedAt: "Last synced:",
    },
    // Location
    location: {
      badge: "Location",
      title: "Heart of Istrian Wine Country",
      description: "Bajkini - A peaceful hillside village surrounded by vineyards and medieval towns",
      nearbyTitle: "Nearby Attractions",
      nearby: [
        { name: "Renowned wineries", distance: "Walking distance" },
        { name: "Rovinj (coast)", distance: "25 min drive" },
        { name: "Motovun", distance: "20 min drive" },
        { name: "Poreč", distance: "30 min drive" },
        { name: "Grožnjan (artist village)", distance: "15 min drive" },
      ],
      wineTourism: "Wine Tourism",
      wineDesc: "World-class wineries within walking distance",
      medievalTowns: "Medieval Towns",
      medievalDesc: "Explore historic hilltop villages",
      coastalAccess: "Coastal Access",
      coastalDesc: "Beautiful Adriatic beaches nearby",
    },
    // Concierge Services
    concierge: {
      badge: "Concierge Services",
      title: "Curated Istrian Experiences",
      description: "Let us take care of every detail of your stay while you enjoy the charms of Istrian luxury. From private chefs to helicopter tours, we provide access to the best experiences Istria has to offer.",
      requestWhatsApp: "Request via WhatsApp",
      note: "All services are optional and can be booked in advance or during your stay. Prices vary by service and season. Contact us for detailed information and availability.",
      categories: {
        dining: "Dining & Events",
        wellness: "Wellness & Relaxation",
        transport: "Transportation",
        experiences: "Istrian Experiences",
        maintenance: "Villa Services",
      },
      services: [
        { title: "Event Organization & Catering", description: "From birthdays to romantic dinners, we provide premium catering, decoration, and everything needed for a perfect event." },
        { title: "Private Steak Master", description: "Experience premium gastronomy in the privacy of your villa. Our professional chef will prepare steaks exactly to your preference, using the finest local and imported ingredients." },
        { title: "Daily Housekeeping", description: "Villa maintenance according to the highest standards. Our professional staff takes care of cleanliness, fresh linens, and tidiness, adapting to your schedule." },
        { title: "Helicopter Tour & Taxi", description: "Experience spectacular panoramic flights over the coastline or use helicopter transport for quick transfers. Various scenic flights and private charters available." },
        { title: "Luxury Yacht Rental", description: "Explore the magical Croatian coast on our luxury vessels. Wide selection of yachts, speedboats, and sailboats, with or without skipper. Full-day or half-day trips with catering available." },
        { title: "Transfers & Car Rental", description: "Seamless transportation from arrival to departure. Luxury limousines with professional drivers or premium vehicles for self-drive. Available 24/7 for all your transportation needs." },
        { title: "Professional Massage", description: "Relax with professional massages in the comfort of your villa. Certified therapists offer various types: from classic to Thai massage, sports massage, or couples treatments." },
        { title: "Istrian Winery Tours", description: "Exclusive wine tastings at the finest Istrian wineries. Meet the winemakers personally and discover the secrets of local wines with expert guidance." },
        { title: "Personalized Tours", description: "Customized excursions tailored to your interests. Explore the hidden gems of the region with luxury transportation." },
        { title: "Diving & Diving School", description: "Discover the magical underwater world of the Adriatic. PADI certified instructors, complete equipment, and a selection of the best diving locations." },
        { title: "Horse Riding Tours", description: "Romantic horseback tours through beautiful nature. Available for beginners and experienced riders, with professional instructors." },
        { title: "Fishing Trip", description: "An authentic fishing experience with local fishermen. Enjoy traditional fishing methods and freshly caught fish prepared on board." },
      ],
    },
    // Amenities
    amenitiesSection: {
      badge: "Amenities",
      title: "Everything You Need for a Perfect Stay",
      description: "Modern luxury meets timeless comfort",
      indoor: "Indoor Amenities",
      outdoor: "Outdoor Amenities",
      indoorItems: [
        "Fully equipped modern kitchen", "Open-concept living & dining", "Air conditioning throughout",
        "Smart TV with streaming services", "High-speed WiFi", "Washer & dryer",
        "Espresso machine", "Two full-size refrigerators", "Wine cellar access", "Large closets in all bedrooms",
      ],
      outdoorItems: [
        "50m² private swimming pool", "Outdoor jacuzzi", "Open-air lounge with fireplace",
        "Sun loungers & pool towels", "Covered dining terrace", "BBQ area",
        "Private parking (3+ cars)", "Garden furniture", "Outdoor shower", "Mountain & garden views",
      ],
      featured: [
        "High-Speed WiFi", "Private Pool", "Air Conditioning", "Smart TV",
        "Washer & Dryer", "Free Parking", "Espresso Machine", "Full Kitchen",
      ],
    },
    // Reviews
    reviewsSection: {
      badge: "Guest Reviews",
      title: "What Our Guests Say",
      basedOn: "Based on {n} reviews",
    },
    // Final CTA
    finalCta: {
      title: "Ready to Experience Roman Luxury in Istria?",
      description: "Contact us today for personalized availability and exclusive offers. Your unforgettable Istrian holiday awaits at Villa in Pietra.",
      button: "Get Your Personalized Offer Now",
      benefits: ["Instant Response", "Custom Pricing", "Direct Communication", "No Hidden Fees"],
      whatsapp: "Hello! I'm interested in booking Villa in Pietra. Could you please send me availability and a personalized offer?",
    },
    // FAQ
    faq: {
      badge: "FAQ",
      title: "Frequently Asked Questions",
      description: "Everything you need to know about your stay at Villa in Pietra",
      stillHaveQuestions: "Still have questions?",
      contactHelp: "We're here to help! Contact us directly via WhatsApp for immediate assistance.",
      items: [
        { q: "Is the pool completely private?", a: "Yes, absolutely! The 50m² swimming pool and jacuzzi are exclusively for villa guests. The entire 2,500m² estate is fully private and fenced, ensuring complete privacy and tranquility during your stay." },
        { q: "How many guests can the villa accommodate?", a: "Villa in Pietra comfortably accommodates up to 8 guests. There are 4 spacious bedrooms, each with its own private bathroom (4.5 bathrooms total), ensuring privacy and comfort for everyone." },
        { q: "Is the villa suitable for families with children?", a: "Yes! The villa is perfect for families. The private pool, large garden, and peaceful setting are ideal for children. Please note: children must be supervised around the pool area. The villa is not suitable for infants under 2 years." },
        { q: "How far is the villa from the sea and main towns?", a: "Villa in Pietra is located in Bajkini, a peaceful hilltop village. The nearest beaches in Rovinj are approximately 25 minutes by car. The charming town of Motovun is 20 minutes away, and you're surrounded by renowned Istrian wineries - some within walking distance." },
        { q: "How does the booking process work?", a: "Simply contact us via WhatsApp with your desired travel dates and number of guests. We'll confirm availability and send you a personalized offer. A €500 cash deposit is required upon arrival and will be returned at checkout if everything is in order." },
        { q: "What is the cancellation policy?", a: "Cancellation terms depend on your specific booking. We'll provide full details when you request your personalized offer. Generally, we offer flexible terms for early cancellations and have specific policies for last-minute changes." },
      ],
    },
    // Footer
    footer: {
      description: "Experience Roman-inspired luxury in the heart of Istria. A private estate combining centuries of history with modern elegance.",
      contact: "Contact",
      whatsappLabel: "WhatsApp:",
      availableWhatsApp: "Available via WhatsApp",
      quickLinks: "Quick Links",
      villaHighlights: "Villa Highlights",
      locationArea: "Location & Area",
      amenities: "Amenities",
      guestReviews: "Guest Reviews",
      checkAvailability: "Check Availability",
      propertyDetails: "Property Details",
      propGuests: "Up to 8 guests",
      propBedrooms: "4 bedrooms, 4.5 bathrooms",
      propPool: "50m² private pool & jacuzzi",
      propEstate: "2,500m² private estate",
      propMinStay: "Minimum 5-night stay",
      propDeposit: "€500 deposit at check-in",
      copyright: "© {year} Villa in Pietra. All rights reserved.",
      managedBy: "Managed by",
    },
    // WhatsApp generic
    whatsappGeneric: "Hello! I'm interested in Villa in Pietra.",
    cookie: {
      text: "We use cookies to improve your experience on our website. By continuing to use the site, you agree to our use of cookies.",
      learnMore: "Learn more",
      accept: "Accept",
      decline: "Decline",
    },
    promoBanner: {
      expiresIn: "Offer expires in",
      specialBadge: "August — available",
      specialDates: "Aug 1 – 4",
      generalBadge: "August — available",
      generalDates: "Aug 12 – 31",
      cta: "Book August now",
      copy: "Copy",
      copied: "Copied",
    },
    // Booking Form
    bookingForm: {
      badge: "Book Your Stay",
      title: "Request Your Personalized Offer",
      description: "Select your dates and we'll send you a custom quote via WhatsApp within minutes",
      guestName: "Full Name",
      guestNamePlaceholder: "e.g. John Smith",
      guestContact: "Phone / Email",
      guestContactPlaceholder: "e.g. +385 91 234 5678 or john@email.com",
      checkIn: "Check-in",
      checkOut: "Check-out",
      guests: "Guests",
      guest: "guest",
      guestsLabel: "guests",
      specialRequests: "Special Requests",
      placeholder: "e.g. Baby cot, early check-in, dietary needs...",
      nightsLabel: "nights",
      datesAvailable: "Dates available",
      overlapWarning: "Selected dates overlap with an existing booking. Please choose different dates.",
      submitButton: "Send Inquiry via WhatsApp",
      sendingLabel: "Sending...",
      minStayNote: "Minimum stay is 5 nights.",
      whatsappTemplate: "Hello! I'd like to inquire about Villa in Pietra.\n\nName: {name}\nContact: {contact}\nCheck-in: {checkIn}\nCheck-out: {checkOut}\nDuration: {nights} nights\nGuests: {guests}\n\nCould you please send me a personalized offer?",
      additionalNote: "Additional note",
      dateNotAvailable: "This date is not available. Please select another date.",
      selectDate: "Select date",
    },
  },

  hr: {
    nav: {
      highlights: "Značajke",
      location: "Lokacija",
      amenities: "Sadržaji",
      reviews: "Recenzije",
      availability: "Dostupnost",
      contactUs: "Kontakt",
      whatsappContact: "WhatsApp kontakt",
    },
    hero: {
      subtitle: "Luksuzna vila rimske inspiracije u srcu Istre",
      perfectRating: "5.0 Savršena ocjena",
      upToGuests: "Do {n} gostiju",
      bedrooms: "{n} spavaće sobe",
      bathrooms: "{n} kupaonice",
      cta: "Provjeri termine i WhatsApp ponudu",
      whatsapp: "Pozdrav! Zanima me Villa in Pietra. Možete li mi poslati informacije o dostupnosti i cijenama?",
    },
    videoTour: {
      badge: "Video tura",
      title: "Doživite Villa in Pietra",
      description: "Krenite na filmsko putovanje kroz našu luksuznu vilu i otkrijte što je čini posebnom",
      pool: "50m² privatni bazen",
      antiques: "Rimske antikne relikvije",
      estate: "2.500m² imanje",
      bedrooms: "4 sobe s kupaonicom",
    },
    villaStory: {
      badge: "Vila",
      title: "Gdje rimska elegancija susreće istarsku autentičnost",
      p1: 'Dobrodošli u <strong>Villa in Pietra</strong>, ekskluzivno luksuzno utočište smješteno u slikovitom selu Bajkini, Istra. Ova šarmantna vila u obliku slova L savršen je spoj istarskog karaktera, elegantnog dizajna i potpune privatnosti.',
      p2: 'Na ulazu vas dočekuje prekrasni <strong>vanjski salon s kaminom</strong> – središnje srce kuće, dizajnirano za opuštanje i druženje. Prostrana terasa sadrži <strong>50m² bazen, jacuzzi i ležaljke</strong> – savršeno za uživanje na istarskom suncu.',
      p3: 'Villa in Pietra ispunjena je dušom i karakterom zahvaljujući <strong>pažljivo odabranim antikvitetima starim nekoliko stoljeća</strong>, koji potječu iz Istre, Toskane i Sicilije. Svaki detalj priča priču i stvara jedinstveno rafinirani i autentični ugođaj.',
      p4: 'Vila se prostire na <strong>privatnom imanju od 2.500m²</strong>, nudeći potpuni mir i ekskluzivnost – idealna za obitelji, grupe prijatelja ili parove koji traže luksuzan odmor u srcu Istre.',
      heritageBadge: "Baština i antikviteti",
      heritageTitle: "Živi muzej prošlih stoljeća",
      heritageDesc: "Svaki komad priča priču, nabavljen s povijesnih imanja diljem Istre, Toskane i Sicilije",
      features: [
        { title: "Srednjovjekovni tapiseriji", description: "Rijetki prizori lova i pomorski tapiseriji iz 16.-17. stoljeća" },
        { title: "Rimski artefakti", description: "Drevni stupovi, kapiteli i arhitektonski elementi pretvoreni u namještaj" },
        { title: "Istarski antikviteti", description: "Ručno odabrani komadi s lokalnih imanja, svaki sa stoljetnom poviješću" },
        { title: "Toskanska i sicilijanska blaga", description: "Pažljivo kurirani namještaj i dekorativna umjetnost talijanskog plemstva" },
      ],
    },
    highlights: {
      badge: "Značajke vile",
      title: "Neusporedivi luksuz i privatnost",
      description: "Doživite savršen spoj drevne elegancije i modernog komfora",
      items: [
        { title: "Privatni 50m² bazen i jacuzzi", description: "Ekskluzivni bazen i grijani jacuzzi okruženi mediteranskim vrtom" },
        { title: "4 spavaće sobe s kupaonicom", description: "Svaka soba s privatnom kupaonicom, antiknim namještajem i modernim komforom" },
        { title: "2.500m² privatno imanje", description: "Potpuna privatnost u mirnom brežuljkastom selu, okruženom vinogradima" },
        { title: "Ugođaj rimske vile", description: "Stoljetni antikviteti iz Istre, Toskane i Sicilije – autentičan luksuz" },
      ],
    },
    gallery: {
      badge: "Foto galerija",
      title: "Istražite Villa in Pietra",
      description: "Otkrijte svaki kutak naše luksuzne vile rimske inspiracije",
      allPhotos: "Sve fotografije",
      exterior: "Eksterijeri i bazen",
      living: "Dnevni boravci",
      kitchen: "Kuhinja",
      dining: "Blagovaonica",
      outdoor: "Vanjski salon",
      bedroom: "Spavaće sobe",
      bathroom: "Kupaonice",
      antiques: "Antikviteti",
      entertainment: "Zabava i djeca",
      footer: "{n} fotografija • Želite vidjeti više? Kontaktirajte nas za kompletnu foto turu i virtualni doživljaj",
    },
    availability: {
      badge: "Dostupnost uživo",
      title: "Provjerite dostupnost u stvarnom vremenu",
      description: "Pregledajte dostupne termine, cijene i posebne ponude jednim pogledom",
      previous: "← Prethodni",
      next: "Sljedeći →",
      available: "Dostupno",
      lastMinute: "Last Minute (-10%)",
      booked: "Zauzeto",
      past: "Prošlo",
      weekdays: ["Pon", "Uto", "Sri", "Čet", "Pet", "Sub", "Ned"],
      perNight: "po noći",
      off: "POPUST!",
      seasonalPricing: "Sezonske cijene",
      peakSummer: "Vrhunac ljeta",
      summerHigh: "Visoka sezona",
      lowSeason: "Niska sezona",
      minimumStay: "Minimalni boravak:",
      nights: "noći",
      deposit: "Depozit:",
      atCheckin: "pri dolasku",
      cleaningFee: "Čišćenje:",
      lastMinuteLabel: "Last minute:",
      offBookings: "popusta za rezervacije unutar 14 dana",
      requestQuote: "Zatražite personaliziranu ponudu",
      disclaimer: "Kalendar je sinkroniziran s Airbnb-om. Za potvrdu u stvarnom vremenu i posebne zahtjeve, kontaktirajte nas izravno putem WhatsAppa.",
      syncedAt: "Zadnja sinkronizacija:",
    },
    location: {
      badge: "Lokacija",
      title: "Srce istarske vinske regije",
      description: "Bajkini – mirno brežuljkasto selo okruženo vinogradima i srednjovjekovnim gradićima",
      nearbyTitle: "U blizini",
      nearby: [
        { name: "Poznate vinarije", distance: "Na pješačkoj udaljenosti" },
        { name: "Rovinj (obala)", distance: "25 min vožnje" },
        { name: "Motovun", distance: "20 min vožnje" },
        { name: "Poreč", distance: "30 min vožnje" },
        { name: "Grožnjan (grad umjetnika)", distance: "15 min vožnje" },
      ],
      wineTourism: "Vinski turizam",
      wineDesc: "Vinarije svjetske klase na pješačkoj udaljenosti",
      medievalTowns: "Srednjovjekovni gradići",
      medievalDesc: "Istražite povijesne gradove na brežuljcima",
      coastalAccess: "Pristup obali",
      coastalDesc: "Prekrasne jadranske plaže u blizini",
    },
    concierge: {
      badge: "Concierge usluge",
      title: "Kurirani istarski doživljaji",
      description: "Prepustite nam brigu o svakom detalju vašeg boravka dok uživate u čarima istarskog luksuza. Od privatnih kuhara do helikopterskih tura, omogućujemo vam pristup najboljim doživljajima koje Istra nudi.",
      requestWhatsApp: "Zatraži putem WhatsAppa",
      note: "Sve usluge su opcionalne i mogu se rezervirati unaprijed ili tijekom boravka. Cijene variraju ovisno o usluzi i sezoni. Kontaktirajte nas za detaljne informacije i dostupnost.",
      categories: {
        dining: "Gastronomija i eventi",
        wellness: "Wellness i opuštanje",
        transport: "Transport",
        experiences: "Istarski doživljaji",
        maintenance: "Usluge u vili",
      },
      services: [
        { title: "Organizacija evenata i catering", description: "Od rođendana do romantičnih večera, osiguravamo premium catering, dekoraciju i sve potrebno za savršen event." },
        { title: "Privatni steak master", description: "Doživite premium gastronomiju u privatnosti vaše vile. Naš profesionalni kuhar priprema steakove točno po vašoj želji, koristeći najfinije lokalne i uvozne sastojke." },
        { title: "Svakodnevno čišćenje", description: "Održavanje vile prema najvišim standardima. Naše profesionalno osoblje brine o čistoći, svježem posteljnom rublju i urednosti, prilagođavajući se vašem rasporedu." },
        { title: "Helikopterska tura i taksi", description: "Doživite spektakularne panoramske letove iznad obale ili koristite helikopterski prijevoz za brze transfere. Dostupni su razni panoramski letovi i privatni charteri." },
        { title: "Najam luksuzne jahte", description: "Istražite čarobnu hrvatsku obalu na našim luksuznim plovilima. Širok izbor jahti, glisera i jedrilica, sa ili bez skipera. Cjelodnevni ili poludnevni izleti s cateringom." },
        { title: "Transferi i najam automobila", description: "Besprijekoran prijevoz od dolaska do odlaska. Luksuzne limuzine s profesionalnim vozačima ili premium vozila za samostalnu vožnju. Dostupno 24/7." },
        { title: "Profesionalna masaža", description: "Opustite se uz profesionalne masaže u udobnosti vaše vile. Certificirani terapeuti nude razne vrste: od klasične do tajlandske masaže, sportske masaže ili tretmana za parove." },
        { title: "Istarske vinske ture", description: "Ekskluzivne degustacije vina u najboljim istarskim vinarijama. Upoznajte vinare osobno i otkrijte tajne lokalnih vina uz stručno vodstvo." },
        { title: "Personalizirane ture", description: "Prilagođeni izleti prema vašim interesima. Istražite skrivene dragulje regije uz luksuzan prijevoz." },
        { title: "Ronjenje i škola ronjenja", description: "Otkrijte čarobni podvodni svijet Jadrana. PADI certificirani instruktori, kompletna oprema i izbor najboljih ronilačkih lokacija." },
        { title: "Jahanje", description: "Romantične ture na konjima kroz prekrasnu prirodu. Dostupno za početnike i iskusne jahače, uz profesionalne instruktore." },
        { title: "Ribolov", description: "Autentično ribolovno iskustvo s lokalnim ribarima. Uživajte u tradicionalnim metodama ribolova i svježe ulovljenoj ribi pripremljenoj na brodu." },
      ],
    },
    amenitiesSection: {
      badge: "Sadržaji",
      title: "Sve što vam treba za savršen boravak",
      description: "Moderan luksuz susreće bezvremenski komfor",
      indoor: "Unutarnji sadržaji",
      outdoor: "Vanjski sadržaji",
      indoorItems: [
        "Potpuno opremljena moderna kuhinja", "Otvoreni koncept dnevnog boravka i blagovaonice", "Klima uređaj u cijeloj vili",
        "Smart TV sa streaming servisima", "Brzi WiFi", "Perilica i sušilica rublja",
        "Espresso aparat", "Dva velika hladnjaka", "Pristup vinskom podrumu", "Veliki ormari u svim sobama",
      ],
      outdoorItems: [
        "50m² privatni bazen", "Vanjski jacuzzi", "Vanjski salon s kaminom",
        "Ležaljke i ručnici za bazen", "Natkrivena terasa za ručavanje", "Roštilj",
        "Privatni parking (3+ auta)", "Vrtni namještaj", "Vanjski tuš", "Pogled na planine i vrt",
      ],
      featured: [
        "Brzi WiFi", "Privatni bazen", "Klima uređaj", "Smart TV",
        "Perilica i sušilica", "Besplatni parking", "Espresso aparat", "Potpuna kuhinja",
      ],
    },
    reviewsSection: {
      badge: "Recenzije gostiju",
      title: "Što kažu naši gosti",
      basedOn: "Na temelju {n} recenzija",
    },
    finalCta: {
      title: "Spremni za rimski luksuz u Istri?",
      description: "Kontaktirajte nas danas za personaliziranu dostupnost i ekskluzivne ponude. Vaš nezaboravan istarski odmor čeka vas u Villa in Pietra.",
      button: "Zatražite personaliziranu ponudu",
      benefits: ["Trenutni odgovor", "Prilagođene cijene", "Izravna komunikacija", "Bez skrivenih troškova"],
      whatsapp: "Pozdrav! Zanima me rezervacija Villa in Pietra. Možete li mi poslati dostupnost i personaliziranu ponudu?",
    },
    faq: {
      badge: "Česta pitanja",
      title: "Često postavljana pitanja",
      description: "Sve što trebate znati o vašem boravku u Villa in Pietra",
      stillHaveQuestions: "Imate još pitanja?",
      contactHelp: "Tu smo da pomognemo! Kontaktirajte nas izravno putem WhatsAppa za trenutnu pomoć.",
      items: [
        { q: "Je li bazen potpuno privatan?", a: "Da, apsolutno! Bazen od 50m² i jacuzzi namijenjeni su isključivo gostima vile. Cijelo imanje od 2.500m² potpuno je privatno i ograđeno, osiguravajući potpunu privatnost i mir tijekom vašeg boravka." },
        { q: "Koliko gostiju vila može primiti?", a: "Villa in Pietra udobno prima do 8 gostiju. Na raspolaganju su 4 prostrane spavaće sobe, svaka sa svojom privatnom kupaonicom (ukupno 4,5 kupaonice), što osigurava privatnost i udobnost za sve." },
        { q: "Je li vila prikladna za obitelji s djecom?", a: "Da! Vila je savršena za obitelji. Privatni bazen, veliki vrt i mirno okruženje idealni su za djecu. Napomena: djeca moraju biti pod nadzorom oko bazena. Vila nije prikladna za djecu mlađu od 2 godine." },
        { q: "Koliko je vila udaljena od mora i glavnih gradova?", a: "Villa in Pietra nalazi se u Bajkinima, mirnom selu na brežuljku. Najbliže plaže u Rovinju udaljene su oko 25 minuta vožnje. Šarmantni gradić Motovun udaljen je 20 minuta, a okruženi ste poznatim istarskim vinarijama – neke su na pješačkoj udaljenosti." },
        { q: "Kako funkcionira postupak rezervacije?", a: "Jednostavno nas kontaktirajte putem WhatsAppa s željenim datumima putovanja i brojem gostiju. Potvrdit ćemo dostupnost i poslati vam personaliziranu ponudu. Depozit od 500€ u gotovini potreban je pri dolasku i vraća se pri odjavi ako je sve u redu." },
        { q: "Kakva je politika otkazivanja?", a: "Uvjeti otkazivanja ovise o vašoj konkretnoj rezervaciji. Pružit ćemo vam sve detalje kada zatražite personaliziranu ponudu. Općenito nudimo fleksibilne uvjete za rana otkazivanja i imamo specifične politike za promjene u zadnji čas." },
      ],
    },
    footer: {
      description: "Doživite luksuz rimske inspiracije u srcu Istre. Privatno imanje koje spaja stoljetnu povijest s modernom elegancijom.",
      contact: "Kontakt",
      whatsappLabel: "WhatsApp:",
      availableWhatsApp: "Dostupno putem WhatsAppa",
      quickLinks: "Brze poveznice",
      villaHighlights: "Značajke vile",
      locationArea: "Lokacija i okolica",
      amenities: "Sadržaji",
      guestReviews: "Recenzije gostiju",
      checkAvailability: "Provjeri dostupnost",
      propertyDetails: "Detalji objekta",
      propGuests: "Do 8 gostiju",
      propBedrooms: "4 spavaće sobe, 4,5 kupaonice",
      propPool: "50m² privatni bazen i jacuzzi",
      propEstate: "2.500m² privatno imanje",
      propMinStay: "Minimalno 5 noći",
      propDeposit: "500€ depozit pri dolasku",
      copyright: "© {year} Villa in Pietra. Sva prava pridržana.",
      managedBy: "Upravljanje:",
    },
    whatsappGeneric: "Pozdrav! Zanima me Villa in Pietra.",
    cookie: {
      text: "Koristimo kolačiće kako bismo poboljšali vaše iskustvo na stranici. Nastavkom korištenja pristajete na upotrebu kolačića.",
      learnMore: "Saznajte više",
      accept: "Prihvati",
      decline: "Odbij",
    },
    promoBanner: {
      expiresIn: "Ponuda ističe za",
      specialBadge: "Kolovoz — slobodno",
      specialDates: "1. – 4. kolovoza",
      generalBadge: "Kolovoz — slobodno",
      generalDates: "12. – 31. kolovoza",
      cta: "Rezerviraj kolovoz",
      copy: "Kopiraj",
      copied: "Kopirano",
    },
    bookingForm: {
      badge: "Rezervirajte boravak",
      title: "Zatražite personaliziranu ponudu",
      description: "Odaberite datume i poslat ćemo vam prilagođenu ponudu putem WhatsAppa u roku nekoliko minuta",
      guestName: "Ime i prezime",
      guestNamePlaceholder: "npr. Ivan Horvat",
      guestContact: "Telefon / Email",
      guestContactPlaceholder: "npr. +385 91 234 5678 ili ivan@email.com",
      checkIn: "Dolazak",
      checkOut: "Odlazak",
      guests: "Gosti",
      guest: "gost",
      guestsLabel: "gostiju",
      specialRequests: "Posebni zahtjevi",
      placeholder: "npr. Dječji krevetić, rani dolazak, prehrambene potrebe...",
      nightsLabel: "noći",
      datesAvailable: "Datumi dostupni",
      overlapWarning: "Odabrani datumi se preklapaju s postojećom rezervacijom. Molimo odaberite druge datume.",
      submitButton: "Pošalji upit putem WhatsAppa",
      sendingLabel: "Slanje...",
      minStayNote: "Minimalni boravak je 5 noći.",
      whatsappTemplate: "Pozdrav! Želio/la bih se raspitati o Villa in Pietra.\n\nIme: {name}\nKontakt: {contact}\nDolazak: {checkIn}\nOdlazak: {checkOut}\nTrajanje: {nights} noći\nBroj gostiju: {guests}\n\nMožete li mi poslati personaliziranu ponudu?",
      additionalNote: "Dodatna napomena",
      dateNotAvailable: "Ovaj datum nije dostupan. Molimo odaberite drugi datum.",
      selectDate: "Odaberite datum",
    },
  },

  de: {
    nav: {
      highlights: "Highlights",
      location: "Lage",
      amenities: "Ausstattung",
      reviews: "Bewertungen",
      availability: "Verfügbarkeit",
      contactUs: "Kontakt",
      whatsappContact: "WhatsApp-Kontakt",
    },
    hero: {
      subtitle: "Luxusvilla im römischen Stil im Herzen Istriens",
      perfectRating: "5,0 Perfekte Bewertung",
      upToGuests: "Bis zu {n} Gäste",
      bedrooms: "{n} Schlafzimmer",
      bathrooms: "{n} Badezimmer",
      cta: "Termine prüfen & WhatsApp-Angebot",
      whatsapp: "Hallo! Ich interessiere mich für die Villa in Pietra. Könnten Sie mir bitte Informationen zur Verfügbarkeit und den Preisen senden?",
    },
    videoTour: {
      badge: "Videotour",
      title: "Erleben Sie Villa in Pietra",
      description: "Unternehmen Sie eine filmische Reise durch unsere Luxusvilla und entdecken Sie, was sie so besonders macht",
      pool: "50m² Privatpool",
      antiques: "Römische Antiquitäten",
      estate: "2.500m² Anwesen",
      bedrooms: "4 Schlafzimmer mit Bad",
    },
    villaStory: {
      badge: "Die Villa",
      title: "Wo römische Eleganz auf istrische Authentizität trifft",
      p1: 'Willkommen in der <strong>Villa in Pietra</strong>, einem exklusiven Luxusrefugium im malerischen Dorf Bajkini, Istrien. Diese charmante L-förmige Villa ist eine perfekte Mischung aus istrischem Charakter, elegantem Design und vollständiger Privatsphäre.',
      p2: 'Beim Betreten werden Sie von einer wunderschönen <strong>Freiluft-Lounge mit Kamin</strong> begrüßt – dem zentralen Herzstück des Hauses, das zum Entspannen und Geselligsein einlädt. Die großzügige Terrasse bietet einen <strong>50m² Swimmingpool, Whirlpool und Sonnenliegen</strong> – perfekt, um die istrische Sonne zu genießen.',
      p3: 'Villa in Pietra ist voller Seele und Charakter, dank <strong>sorgfältig ausgewählter Antiquitäten aus mehreren Jahrhunderten</strong>, die aus Istrien, der Toskana und Sizilien stammen. Jedes Detail erzählt eine Geschichte und schafft eine einzigartig raffinierte und authentische Atmosphäre.',
      p4: 'Die Villa erstreckt sich über ein <strong>2.500m² großes Privatanwesen</strong> und bietet völlige Ruhe und Exklusivität – ideal für Familien, Freundesgruppen oder Paare, die einen luxuriösen Urlaub im Herzen Istriens suchen.',
      heritageBadge: "Kulturerbe & Antiquitäten",
      heritageTitle: "Ein lebendiges Museum vergangener Jahrhunderte",
      heritageDesc: "Jedes Stück erzählt eine Geschichte, bezogen von historischen Anwesen in Istrien, der Toskana und Sizilien",
      features: [
        { title: "Mittelalterliche Wandteppiche", description: "Seltene Jagdszenen und maritime Wandteppiche aus dem 16.–17. Jahrhundert" },
        { title: "Römische Artefakte", description: "Antike Säulen, Kapitelle und architektonische Elemente, umfunktioniert zu Möbeln" },
        { title: "Istrische Antiquitäten", description: "Handverlesene Stücke von lokalen Anwesen, jedes mit jahrhundertelanger Geschichte" },
        { title: "Toskanische & sizilianische Schätze", description: "Sorgfältig kuratierte Möbel und dekorative Kunst des italienischen Adels" },
      ],
    },
    highlights: {
      badge: "Villa-Highlights",
      title: "Unvergleichlicher Luxus & Privatsphäre",
      description: "Erleben Sie die perfekte Verbindung von antiker Eleganz und modernem Komfort",
      items: [
        { title: "Privater 50m² Pool & Whirlpool", description: "Exklusiver Swimmingpool und beheizter Whirlpool, umgeben von einem mediterranen Garten" },
        { title: "4 Schlafzimmer mit eigenem Bad", description: "Jedes Schlafzimmer mit privatem Badezimmer, antiken Möbeln und modernem Komfort" },
        { title: "2.500m² Privatanwesen", description: "Vollständige Privatsphäre in einem ruhigen Hügeldorf, umgeben von Weinbergen" },
        { title: "Römische Villen-Atmosphäre", description: "Jahrhundertealte Antiquitäten aus Istrien, der Toskana und Sizilien – authentischer Luxus" },
      ],
    },
    gallery: {
      badge: "Fotogalerie",
      title: "Entdecken Sie Villa in Pietra",
      description: "Entdecken Sie jede Ecke unserer Luxusvilla im römischen Stil",
      allPhotos: "Alle Fotos",
      exterior: "Außen & Pool",
      living: "Wohnräume",
      kitchen: "Küche",
      dining: "Essbereich",
      outdoor: "Außenlounge",
      bedroom: "Schlafzimmer",
      bathroom: "Badezimmer",
      antiques: "Antiquitäten",
      entertainment: "Unterhaltung & Familie",
      footer: "{n} Fotos • Möchten Sie mehr sehen? Kontaktieren Sie uns für eine vollständige Fototour und ein virtuelles Erlebnis",
    },
    availability: {
      badge: "Live-Verfügbarkeit",
      title: "Verfügbarkeit in Echtzeit prüfen",
      description: "Sehen Sie verfügbare Termine, Preise und Sonderangebote auf einen Blick",
      previous: "← Zurück",
      next: "Weiter →",
      available: "Verfügbar",
      lastMinute: "Last Minute (-10%)",
      booked: "Gebucht",
      past: "Vergangen",
      weekdays: ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"],
      perNight: "pro Nacht",
      off: "RABATT!",
      seasonalPricing: "Saisonpreise",
      peakSummer: "Hochsommer",
      summerHigh: "Sommerhauptsaison",
      lowSeason: "Nebensaison",
      minimumStay: "Mindestaufenthalt:",
      nights: "Nächte",
      deposit: "Kaution:",
      atCheckin: "beim Check-in",
      cleaningFee: "Endreinigung:",
      lastMinuteLabel: "Last Minute:",
      offBookings: "Rabatt bei Buchungen innerhalb von 14 Tagen",
      requestQuote: "Individuelles Angebot anfordern",
      disclaimer: "Kalender mit Airbnb synchronisiert. Für Echtzeitbestätigung und Sonderwünsche kontaktieren Sie uns bitte direkt per WhatsApp.",
      syncedAt: "Letzte Synchronisation:",
    },
    location: {
      badge: "Lage",
      title: "Im Herzen der istrischen Weinregion",
      description: "Bajkini – Ein ruhiges Hügeldorf umgeben von Weinbergen und mittelalterlichen Städtchen",
      nearbyTitle: "In der Nähe",
      nearby: [
        { name: "Renommierte Weingüter", distance: "Zu Fuß erreichbar" },
        { name: "Rovinj (Küste)", distance: "25 Min. Fahrt" },
        { name: "Motovun", distance: "20 Min. Fahrt" },
        { name: "Poreč", distance: "30 Min. Fahrt" },
        { name: "Grožnjan (Künstlerdorf)", distance: "15 Min. Fahrt" },
      ],
      wineTourism: "Weintourismus",
      wineDesc: "Weltklasse-Weingüter in Gehweite",
      medievalTowns: "Mittelalterliche Städte",
      medievalDesc: "Entdecken Sie historische Bergdörfer",
      coastalAccess: "Küstenzugang",
      coastalDesc: "Wunderschöne Adriastrände in der Nähe",
    },
    concierge: {
      badge: "Concierge-Service",
      title: "Kuratierte istrische Erlebnisse",
      description: "Überlassen Sie uns die Betreuung jedes Details Ihres Aufenthalts, während Sie den Charme des istrischen Luxus genießen. Von Privatköchen bis hin zu Hubschrauberrundflügen bieten wir Zugang zu den besten Erlebnissen, die Istrien zu bieten hat.",
      requestWhatsApp: "Per WhatsApp anfragen",
      note: "Alle Dienstleistungen sind optional und können im Voraus oder während Ihres Aufenthalts gebucht werden. Die Preise variieren je nach Service und Saison. Kontaktieren Sie uns für detaillierte Informationen und Verfügbarkeit.",
      categories: {
        dining: "Gastronomie & Events",
        wellness: "Wellness & Entspannung",
        transport: "Transport",
        experiences: "Istrische Erlebnisse",
        maintenance: "Villa-Services",
      },
      services: [
        { title: "Eventorganisation & Catering", description: "Von Geburtstagen bis zu romantischen Abendessen bieten wir Premium-Catering, Dekoration und alles für ein perfektes Event." },
        { title: "Privater Steak-Master", description: "Erleben Sie Premium-Gastronomie in der Privatsphäre Ihrer Villa. Unser professioneller Koch bereitet Steaks genau nach Ihrem Geschmack zu, mit den feinsten lokalen und importierten Zutaten." },
        { title: "Tägliche Reinigung", description: "Villa-Pflege nach höchsten Standards. Unser professionelles Personal kümmert sich um Sauberkeit, frische Bettwäsche und Ordnung, angepasst an Ihren Zeitplan." },
        { title: "Hubschraubertour & Taxi", description: "Erleben Sie spektakuläre Panoramaflüge über die Küste oder nutzen Sie den Hubschraubertransfer für schnelle Transfers. Verschiedene Rundflüge und Privatcharter verfügbar." },
        { title: "Luxusyacht-Vermietung", description: "Erkunden Sie die magische kroatische Küste auf unseren Luxusschiffen. Große Auswahl an Yachten, Schnellbooten und Segelbooten, mit oder ohne Skipper. Ganztages- oder Halbtagesausflüge mit Catering." },
        { title: "Transfers & Autovermietung", description: "Nahtloser Transport von der Ankunft bis zur Abreise. Luxuslimousinen mit professionellen Fahrern oder Premiumfahrzeuge zur Selbstfahrt. Rund um die Uhr verfügbar." },
        { title: "Professionelle Massage", description: "Entspannen Sie sich mit professionellen Massagen im Komfort Ihrer Villa. Zertifizierte Therapeuten bieten verschiedene Arten an: von klassischer bis Thai-Massage, Sportmassage oder Paarbehandlungen." },
        { title: "Istrische Weintouren", description: "Exklusive Weinverkostungen in den besten istrischen Weingütern. Lernen Sie die Winzer persönlich kennen und entdecken Sie die Geheimnisse lokaler Weine mit fachkundiger Begleitung." },
        { title: "Personalisierte Touren", description: "Maßgeschneiderte Ausflüge nach Ihren Interessen. Entdecken Sie die verborgenen Schätze der Region mit Luxustransport." },
        { title: "Tauchen & Tauchschule", description: "Entdecken Sie die magische Unterwasserwelt der Adria. PADI-zertifizierte Instruktoren, komplette Ausrüstung und eine Auswahl der besten Tauchplätze." },
        { title: "Reittouren", description: "Romantische Ausritte durch wunderschöne Natur. Verfügbar für Anfänger und erfahrene Reiter, mit professionellen Instruktoren." },
        { title: "Angelausflug", description: "Ein authentisches Angelerlebnis mit lokalen Fischern. Genießen Sie traditionelle Fangmethoden und frisch gefangenen Fisch, an Bord zubereitet." },
      ],
    },
    amenitiesSection: {
      badge: "Ausstattung",
      title: "Alles, was Sie für einen perfekten Aufenthalt brauchen",
      description: "Moderner Luxus trifft auf zeitlosen Komfort",
      indoor: "Innenausstattung",
      outdoor: "Außenausstattung",
      indoorItems: [
        "Voll ausgestattete moderne Küche", "Offener Wohn- und Essbereich", "Klimaanlage in der gesamten Villa",
        "Smart-TV mit Streaming-Diensten", "Highspeed-WLAN", "Waschmaschine & Trockner",
        "Espressomaschine", "Zwei große Kühlschränke", "Zugang zum Weinkeller", "Große Schränke in allen Zimmern",
      ],
      outdoorItems: [
        "50m² privater Swimmingpool", "Außen-Whirlpool", "Freiluft-Lounge mit Kamin",
        "Sonnenliegen & Poolhandtücher", "Überdachte Essterrasse", "Grillbereich",
        "Privater Parkplatz (3+ Autos)", "Gartenmöbel", "Außendusche", "Berg- und Gartenblick",
      ],
      featured: [
        "Highspeed-WLAN", "Privatpool", "Klimaanlage", "Smart-TV",
        "Waschmaschine & Trockner", "Kostenloser Parkplatz", "Espressomaschine", "Vollküche",
      ],
    },
    reviewsSection: {
      badge: "Gästebewertungen",
      title: "Was unsere Gäste sagen",
      basedOn: "Basierend auf {n} Bewertungen",
    },
    finalCta: {
      title: "Bereit für römischen Luxus in Istrien?",
      description: "Kontaktieren Sie uns noch heute für personalisierte Verfügbarkeit und exklusive Angebote. Ihr unvergesslicher istrischer Urlaub erwartet Sie in der Villa in Pietra.",
      button: "Jetzt individuelles Angebot anfordern",
      benefits: ["Sofortige Antwort", "Individuelle Preise", "Direkte Kommunikation", "Keine versteckten Kosten"],
      whatsapp: "Hallo! Ich interessiere mich für eine Buchung der Villa in Pietra. Könnten Sie mir bitte die Verfügbarkeit und ein individuelles Angebot senden?",
    },
    faq: {
      badge: "FAQ",
      title: "Häufig gestellte Fragen",
      description: "Alles, was Sie über Ihren Aufenthalt in der Villa in Pietra wissen müssen",
      stillHaveQuestions: "Noch Fragen?",
      contactHelp: "Wir sind für Sie da! Kontaktieren Sie uns direkt per WhatsApp für sofortige Hilfe.",
      items: [
        { q: "Ist der Pool vollständig privat?", a: "Ja, absolut! Der 50m² Swimmingpool und der Whirlpool sind ausschließlich für Villengäste bestimmt. Das gesamte 2.500m² große Anwesen ist vollständig privat und eingezäunt und gewährleistet absolute Privatsphäre und Ruhe während Ihres Aufenthalts." },
        { q: "Wie viele Gäste kann die Villa beherbergen?", a: "Die Villa in Pietra bietet komfortabel Platz für bis zu 8 Gäste. Es stehen 4 geräumige Schlafzimmer zur Verfügung, jedes mit eigenem Badezimmer (insgesamt 4,5 Badezimmer), um Privatsphäre und Komfort für alle zu gewährleisten." },
        { q: "Ist die Villa für Familien mit Kindern geeignet?", a: "Ja! Die Villa ist perfekt für Familien. Der Privatpool, der große Garten und die ruhige Umgebung sind ideal für Kinder. Bitte beachten Sie: Kinder müssen im Poolbereich beaufsichtigt werden. Die Villa ist nicht für Kleinkinder unter 2 Jahren geeignet." },
        { q: "Wie weit ist die Villa vom Meer und den Hauptstädten entfernt?", a: "Die Villa in Pietra befindet sich in Bajkini, einem ruhigen Hügeldorf. Die nächsten Strände in Rovinj sind ca. 25 Autominuten entfernt. Das charmante Städtchen Motovun ist 20 Minuten entfernt, und Sie sind von renommierten istrischen Weingütern umgeben – einige in Gehweite." },
        { q: "Wie funktioniert der Buchungsprozess?", a: "Kontaktieren Sie uns einfach per WhatsApp mit Ihren gewünschten Reisedaten und der Gästezahl. Wir bestätigen die Verfügbarkeit und senden Ihnen ein personalisiertes Angebot. Eine Kaution von 500€ in bar ist bei der Ankunft erforderlich und wird beim Checkout zurückgegeben, wenn alles in Ordnung ist." },
        { q: "Wie sind die Stornierungsbedingungen?", a: "Die Stornierungsbedingungen hängen von Ihrer konkreten Buchung ab. Alle Details erhalten Sie, wenn Sie Ihr personalisiertes Angebot anfordern. Generell bieten wir flexible Bedingungen für frühzeitige Stornierungen und haben spezifische Richtlinien für kurzfristige Änderungen." },
      ],
    },
    footer: {
      description: "Erleben Sie Luxus im römischen Stil im Herzen Istriens. Ein Privatanwesen, das Jahrhunderte Geschichte mit moderner Eleganz verbindet.",
      contact: "Kontakt",
      whatsappLabel: "WhatsApp:",
      availableWhatsApp: "Erreichbar per WhatsApp",
      quickLinks: "Schnelllinks",
      villaHighlights: "Villa-Highlights",
      locationArea: "Lage & Umgebung",
      amenities: "Ausstattung",
      guestReviews: "Gästebewertungen",
      checkAvailability: "Verfügbarkeit prüfen",
      propertyDetails: "Objektdetails",
      propGuests: "Bis zu 8 Gäste",
      propBedrooms: "4 Schlafzimmer, 4,5 Badezimmer",
      propPool: "50m² Privatpool & Whirlpool",
      propEstate: "2.500m² Privatanwesen",
      propMinStay: "Mindestaufenthalt 5 Nächte",
      propDeposit: "500€ Kaution beim Check-in",
      copyright: "© {year} Villa in Pietra. Alle Rechte vorbehalten.",
      managedBy: "Verwaltet von",
    },
    whatsappGeneric: "Hallo! Ich interessiere mich für die Villa in Pietra.",
    cookie: {
      text: "Wir verwenden Cookies, um Ihr Erlebnis auf unserer Website zu verbessern. Durch die weitere Nutzung stimmen Sie der Verwendung von Cookies zu.",
      learnMore: "Mehr erfahren",
      accept: "Akzeptieren",
      decline: "Ablehnen",
    },
    promoBanner: {
      expiresIn: "Angebot läuft ab in",
      specialBadge: "Spezieller Termin",
      specialDates: "17. – 26. Mai",
      generalBadge: "Andere Buchungen",
      generalDates: "Alle anderen Termine",
      cta: "Mit Rabatt buchen",
      copy: "Kopieren",
      copied: "Kopiert",
    },
    bookingForm: {
      badge: "Aufenthalt buchen",
      title: "Fordern Sie Ihr individuelles Angebot an",
      description: "Wählen Sie Ihre Daten und wir senden Ihnen innerhalb weniger Minuten ein individuelles Angebot per WhatsApp",
      guestName: "Vollständiger Name",
      guestNamePlaceholder: "z.B. Max Mustermann",
      guestContact: "Telefon / E-Mail",
      guestContactPlaceholder: "z.B. +49 170 1234567 oder max@email.com",
      checkIn: "Anreise",
      checkOut: "Abreise",
      guests: "Gäste",
      guest: "Gast",
      guestsLabel: "Gäste",
      specialRequests: "Besondere Wünsche",
      placeholder: "z.B. Babybett, früher Check-in, Ernährungsbedürfnisse...",
      nightsLabel: "Nächte",
      datesAvailable: "Termine verfügbar",
      overlapWarning: "Die gewählten Daten überschneiden sich mit einer bestehenden Buchung. Bitte wählen Sie andere Daten.",
      submitButton: "Anfrage per WhatsApp senden",
      sendingLabel: "Senden...",
      minStayNote: "Mindestaufenthalt beträgt 5 Nächte.",
      whatsappTemplate: "Hallo! Ich möchte mich über die Villa in Pietra erkundigen.\n\nName: {name}\nKontakt: {contact}\nAnreise: {checkIn}\nAbreise: {checkOut}\nDauer: {nights} Nächte\nGäste: {guests}\n\nKönnten Sie mir bitte ein individuelles Angebot senden?",
      additionalNote: "Zusätzliche Anmerkung",
      dateNotAvailable: "Dieses Datum ist nicht verfügbar. Bitte wählen Sie ein anderes Datum.",
      selectDate: "Datum wählen",
    },
  },
};

export default translations;
